import React, { useEffect, useState } from 'react';
import { Col, Row, Typography, Skeleton } from 'antd';


// import { Doughnut } from 'react-chartjs-2';
import { DoughnutChart } from './dougnutChart';
import { MDBCard, MDBCardText } from 'mdbreact';
import Firebase from "../Firebase/Firebase";
import { useListVals } from "../Firebase/databaseHooks";
import { ref, getDatabase } from 'firebase/database';
import { getAuth } from "firebase/auth";
import { Card } from '@mui/material';
import { HorizontalBar } from './horizontalBar';
import { useNavigate } from 'react-router-dom';
import { isActiveUserStatus } from "../../constants/userStatus";


var db = getDatabase(Firebase);
var auth = getAuth(Firebase);

const Home = () => {
  const [checkedData, setCheckedData] = useState(true);
  const [userArray, userLoading] = useListVals(ref(db, "talmidsdb/users"));
  const [countriesArray, countriesLoading] = useListVals(ref(db, "talmidsdb/countries"));
  const [lessonArray, lessonsLoading] = useListVals(ref(db, "talmidsdb/lessons"));
  const [quizArray, quizzesLoading] = useListVals(ref(db, "talmidsdb/quizzes"));
  const [languages, languagesLoading] = useListVals(ref(db, "talmidsdb/languages"));
  const [communities, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
  const [groups, groupsLoading] = useListVals(ref(db, "talmidsdb/groups"));
  const [languageArray, setLanguageArray] = useState([]);
  const [countNum, setCountNum] = useState(0);
  const [userCount, setUserCount] = useState([]);
  const [countLanguages, setCountLanguages] = useState([]);
  const [countriesWithUsers, setCountriesWithUsers] = useState([]);

  const navigate = useNavigate();
  const isLoading = userLoading || countriesLoading || lessonsLoading || quizzesLoading
    || languagesLoading || communitiesLoading || groupsLoading;

  useEffect(() => {
    var countArray = [];
    const user = auth.currentUser;
    if (user) {
      if (userArray) {
        var use = userArray.find(x => (user.email) === x.email);
        var role = use?.userRole;
        var array = [];
        switch (role) {
          case "SuperUser":
            array = userArray;
            break;

          case "RegIntlOrgStaff":
            array = userArray.filter(x => x.userRole !== "SuperUser");
            break;

          case "IntlOrgStaff":
            array = userArray.filter(x => (x.userRole !== "SuperUser" && x.userRole !== "RegIntlOrgStaff"));
            break;

          case "LclOrgStaff":
            array = userArray.filter(x => (x.userRole !== "SuperUser" &&
              x.userRole !== "RegIntlOrgStaff" && x.userRole !== "IntlOrgStaff") &&
              (x.organisationID === use?.organisationID));
            break;

          case "LclOrgLeader":
            array = userArray.filter(x => (x.userRole !== "SuperUser" &&
              x.userRole !== "RegIntlOrgStaff" && x.userRole !== "IntlOrgStaff")
              && (x.organisationID === use?.organisationID));
            break;

          default:
            array = [];
        }

        array = userArray.filter((x) => isActiveUserStatus(x.userStatus));
        setUserCount([...array]);
        countArray = [...array];
      }

      var count = 0;
      if (countriesArray) {
        countriesArray.map((country) => {
          country.count = 0;
          countArray.map((user) => {
            if ((country.name + "-" + country.alpha3Code) === user.countryID) {
              count = count + 1;
              setCountNum(count)
              country.count = country.count + 1;
            }
          });
        });
      }

      if (languages) {
        var tempArray = [];
        var tempCountArray = [];
        languages.map((language) => {
          tempArray.push(language);
          var filteredLessons = lessonArray?.filter(x => x.language === language.languageID);
          var object = language;
          object.count = filteredLessons.length;
          tempCountArray.push(object);
        });
        setCountLanguages([...tempCountArray]);
        setLanguageArray([...tempArray]);
      }

      if (countriesArray) {
        const countriesWithCounts = countriesArray.map((country) => {
          const userCount = countArray.filter((user) => user.countryID === country.id).length;
          return {
            ...country,
            count: userCount
          };
        });

        const sortedCountries = countriesWithCounts.sort((a, b) => b.count - a.count);
        setCountriesWithUsers(sortedCountries);

        const totalCount = sortedCountries.reduce((sum, country) => sum + country.count, 0);
        setCountNum(totalCount);
      }
    }
  }, [languages, countriesArray, userArray, lessonArray, communities, groups, quizArray]);

  return (
    <div className="py-4 mt-4">
      {isLoading ? (
        <Row gutter={[8, 6]}>
          <Col span={6}>
            <Card style={{ borderRadius: 15, height: '110vh', padding: 12 }}>
              <Row className="flex col justify-start gap-4 p-3">
                {Array.from({ length: 7 }).map((_, index) => (
                  <Col md={11} key={`stats-skeleton-${index}`}>
                    <Card bordered={false} style={{ borderRadius: 10 }} className="p-2 w-100">
                      <Skeleton active title={{ width: '70%' }} paragraph={{ rows: 1, width: ['40%'] }} />
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>
          <Col sm={18}>
            <Row className="w-100" gutter={[6, 16]}>
              <Col span={24}>
                <Card className="w-100 p-6">
                  <Skeleton active title={{ width: '45%' }} paragraph={{ rows: 1, width: ['60%'] }} />
                  <div style={{ marginTop: 16 }}>
                    <Skeleton.Input active style={{ width: '100%', height: 350 }} block />
                  </div>
                </Card>
              </Col>
              <Col span={24}>
                <Card className="w-100 p-6 rounded-lg">
                  <Skeleton active title={{ width: '35%' }} paragraph={{ rows: 1, width: ['55%'] }} />
                  <div style={{ marginTop: 16 }}>
                    <Skeleton.Input active style={{ width: '100%', height: 280 }} block />
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row gutter={[8, 6]}>
          <Col span={6}>
            <Card style={{ borderRadius: 15, height: '110vh' }}>
              <Row className="flex col justify-start gap-4 p-3">
                {/* Card for various statistics */}
                {[
                  { label: 'Active Users', value: userCount?.length, color: '#F57F29', link: "users" },
                  { label: 'Countries', value: countriesArray?.length, color: '#B6BE34' },
                  {
                    label: 'Active Communities',
                    value: communities?.filter(x => !x.inactivationDate).length,
                    color: '#51195D',
                  },
                  { label: 'Active Groups', value: groups?.filter(x => x.groupStatus === 'Active').length, color: '#B6BE34', link: "groups" },
                  { label: 'Active Languages', value: languageArray?.length, color: '#F57F29' },
                  { label: 'Lessons', value: lessonArray?.length, color: '#51195D', link: "lessons" },
                  { label: 'Quizzes', value: quizArray?.length, color: '#5191CD', link: "quizzes" },
                ].map(({ label, value, color, link }, index) => (
                  <Col md={11} key={index} onClick={() => link ? navigate(`/${link}`) : {}}>
                    <Card
                      bordered={false}
                      style={{
                        backgroundColor: `${color}`,
                        borderRadius: 10
                      }}
                      className="p-2 w-100"
                    >
                      <text>
                        <Typography.Text className="font-weight-bolder text-[12px] text-white">{label}</Typography.Text>
                      </text>
                      <h3 className="font-weight-bolder">
                        <Typography.Text className={`${color}-text font-weight-bolder text-white text-[30px]`}>
                          <strong>{value}</strong>
                        </Typography.Text>
                      </h3>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>
          <Col sm={18}>
            <Row className="w-100" gutter={[6, 16]}>
              <Col span={24}>
                <Card className="w-100 p-6">
                  <div className="text-left">
                    <div className="d-flex flex-row justify-content-between">
                      <div>
                        <h5 className="font-weight-bold">
                          <Typography.Text family="Nunito">Number of users in each respective country</Typography.Text>
                        </h5>
                      </div>
                    </div>
                    <div style={{
                      alignContent: "center",
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 350,
                      backgroundColor: 'whitesmoke'
                    }}>
                      <DoughnutChart data={countriesWithUsers} />
                    </div>
                  </div>
                </Card>
              </Col>
              <hr />
              <Col span={24}>
                <Card className="w-100 p-6 rounded-lg">
                  <div className="text-left">
                    <div className="d-flex flex-row justify-content-between">
                      <div>
                        <h5 className="font-weight-bold">
                          <Typography.Text>Lessons Per Language</Typography.Text>
                        </h5>
                        <MDBCardText>
                          <Typography.Text>Number of lessons in each respective language</Typography.Text>
                        </MDBCardText>
                      </div>
                    </div>
                    <Row className="px-3 bg-[whitesmoke] rounded-sm" center>
                      {/* <HorizontalBar data={countLanguages} /> */}
                    </Row>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default Home;
